module.exports = __webpack_public_path__ + "2f3a1cffa3175c7a96a4929a8f7dd804.svg";